module.exports = __webpack_public_path__ + "img/inactive-19.84e6f0eb.svg";